/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './controls.styles.css';
import './controlBar.styles.css';
import * as STATES from '../../../core/states/player.states';

export default function ControlsVideoProgressbar({ config, videoPlayer }) {
  let isSeeking = false;

  const progress = document
    .getElementById(config.targetId)
    .querySelector('.tpx-video-progress-duration');

  useEffect(() => {
    document.addEventListener('dragover', (event) => {
      event.preventDefault();
    });
    const timerDuration = setInterval(() => {
      if (isSeeking) return;
      if (videoPlayer.state === STATES.ERROR) {
        window.clearInterval(timerDuration);
      }
      const percentVideo = (100 * videoPlayer.currentTime) / videoPlayer.duration;

      const cursor = document
        .getElementById(config.targetId)
        .querySelector('#myCursorvideoprogress');
      const currentTimeBar = document
        .getElementById(config.targetId)
        .querySelector('.tpx-video-progress-currenttime');
      currentTimeBar.style.width = `${percentVideo}%`;
      cursor.style.setProperty('left', `calc(${percentVideo}% - 6px)`);
    }, 500);
    return () => {
      // eslint-disable-next-line no-undef
      window.clearInterval(timerDuration);
    };
  });

  function handleProgressClick(event) {
    const rect = progress.getBoundingClientRect();
    const percentVideo = (100 * (event.pageX - rect.x)) / rect.width;
    const currentTimeBar = document
      .getElementById(config.targetId)
      .querySelector('.tpx-video-progress-currenttime');
    currentTimeBar.style.width = `${percentVideo}%`;
    videoPlayer.seekTo(percentVideo);
  }

  function handleMove(event) {
    isSeeking = true;
    const rect = progress.getBoundingClientRect();
    const xPos = event.touches ? event.touches[0].pageX : event.pageX;
    if (xPos > 0) {
      // eslint-disable-next-line no-param-reassign
      event.target.style.left = `${xPos - rect.x}px`;
    }
  }

  function handleLeave(event) {
    const xPos = event.changedTouches ? event.changedTouches[0].pageX : event.pageX;
    const rect = progress.getBoundingClientRect();
    const percentVideo = (100 * xPos - rect.x) / rect.width;
    isSeeking = false;

    videoPlayer.seekTo(percentVideo);
  }

  function handleStart() {
    isSeeking = true;
  }

  return (
    <div className={'tpx-video-progress'}>
      <div className={'tpx-video-progress-duration'} onClick={handleProgressClick}></div>
      <div className="tpx-video-progress-currenttime" onClick={handleProgressClick}></div>
      <span
        id={'myCursorvideoprogress'}
        className={'pointer indicator'}
        onDrag={handleMove}
        onDragEnd={handleLeave}
        onDragStart={handleStart}
        onTouchMove={handleMove}
        onTouchEnd={handleLeave}
        onTouchStart={handleStart}
      ></span>
    </div>
  );
}

ControlsVideoProgressbar.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
};
